<!-- header start -->
<div class="sggs-main-header">
  <div class="logo-wrapper" [class.handset-logo-wrapper]="isHandsetPortrait">
    <a class="" href="/">
      <img alt="Guru Granth Sahib Logo" src="/assets/images/TGGSP Logo.svg" />
    </a>
  </div>
  <div *ngIf="!isHandsetPortrait" class="menu-items-wrapper">

    <div id="ggs" [matMenuTriggerFor]="ggsMenu" class="header-menu-tab " id="GuruSahib">
      <span [ngClass]="activeItem == 'guru-granth-sahib'  ? '' : '' "> {{ "Guru Granth Sahib" | translate }}</span>
      <mat-icon>arrow_drop_down</mat-icon>
    </div>
    <mat-menu #ggsMenu="matMenu">
      <a class="header-menu-item"
        [href]="fetchLanguage() != 'en' ? '/info/panjabi/guru-granth-sahib' : '/info/english/guru-granth-sahib'"> {{
        "What is the Guru Granth Sahib?" | translate }} </a>
      <a class="header-menu-item" href="/search"> {{ "Compositions" | translate }} </a>
    </mat-menu>


    <div id="terms" class="header-menu-tab " [ngClass]="activeItem == 'dictionary'  ? 'active' : '' ">
      <a class="header-menu-item" target="_blank" href="https://gurugranthsahibdictionary.io"> {{ "dictionary" |
        translate }} </a>
    </div>


    <div id="project" [matMenuTriggerFor]="projectMenu" class="header-menu-tab" [class.active]="isTabActive('project')">
      {{ "project" | translate }} <mat-icon>arrow_drop_down</mat-icon>
    </div>
    <mat-menu #projectMenu="matMenu">

      <a class="header-menu-item"
        [href]="fetchLanguage() != 'en' ? '/info/panjabi/approach' : '/info/english/approach'"> {{ "approach" |
        translate }} </a>
      <a class="header-menu-item"
        [href]="fetchLanguage() != 'en' ? '/info/panjabi/methodology' : '/info/english/methodology'"> {{ "Methodology" |
        translate }} </a>
      <a class="header-menu-item" href="/glossary"> {{ "glossary" | translate }} </a>
      <a class="header-menu-item"
        [href]="fetchLanguage() != 'en' ? '/info/panjabi/navigation' : '/info/english/navigation'"> {{ "Navigation" |
        translate }} </a>
      <a class="header-menu-item"
        [href]="fetchLanguage() != 'en' ? '/info/panjabi/bibliography' : '/info/english/bibliography'"> {{
        "bibliography" | translate }} </a>
      <a class="header-menu-item" [href]="fetchLanguage() != 'en' ? '/info/panjabi/project' : '/info/english/project'"
        target="_blank"> {{ "initiative" | translate }} </a>
      <!-- <a class="header-menu-item"  [href]="fetchLanguage() != 'en' ? '/info/panjabi/project' : '/info/english/project'"> {{ "Project" | translate }} </a> -->

    </mat-menu>
    <div [matMenuTriggerFor]="supportMenu" [class.active]="isTabActive('support')" class="header-menu-tab">
      {{ "About Us" | translate }} <mat-icon>arrow_drop_down</mat-icon>
    </div>
    <mat-menu #supportMenu="matMenu">

      <a class="header-menu-item" [href]="fetchLanguage() != 'en' ? '/info/panjabi/team' : '/info/english/team'"> {{
        "team" | translate }} </a>
      <a class="header-menu-item" href="https://jobs.sikhri.org" target="_blank"> {{ "Careers" | translate }} </a>
      <!-- <a class="header-menu-item" href="https://sikhri.org/donate" target="_blank"> {{ "Donate" | translate }} </a> -->
      <a class="header-menu-item"
        [href]="fetchLanguage() != 'en' ? '/info/panjabi/contact-us' : '/info/english/contact-us'"> {{ "Contact Us" |
        translate }} </a>
     <!--  <a class="header-menu-item"
        [href]="fetchLanguage() != 'en' ? '/info/panjabi/articles' : '/info/english/articles'"> {{ "Articles" |
        translate }} </a> -->
    </mat-menu>
    <!--   <div 
      class="header-menu-tab "
      [ngClass]="activeItem == 'dictionary'  ? 'active' : '' "
    >
       <a class="header-menu-item" [href]="fetchLanguage() != 'en' ? '/info/panjabi/contact-us' : '/info/english/contact-us'"> {{ "Subscribe" | translate }} </a>
    </div> -->
  </div>
  <div class="toggle-options-wrapper">

    <ng-container *ngIf="!isHandsetPortrait">
      <span>
        <button id="donate" style="position: relative;left: 2px;" class="select-donate-button" (click)="onDonateClick()"
          mat-button>
          {{ fetchLanguage() == "en" ? "Donate" : "Donate" | translate }}
        </button>

        <mat-icon class="icon-info" (click)="startTour()">info</mat-icon>
      </span>
      <span>&nbsp;&nbsp;</span>
      <span>
        <button id="language" style="position: relative;left: 2px;"
          (click)="onSelectLanguage(fetchLanguage() === 'en' ? 'pa' : 'en')" class="select-language-button" mat-button
          [matMenuTriggerFor]="menu">
          {{ fetchLanguage() != "en" ? "English" : "panjabi" | translate }}
        </button>
        <mat-menu #menu="matMenu">
          <button (click)="onSelectLanguage('en')" class="selectable-language-button" mat-menu-item>
            English
          </button>
          <button (click)="onSelectLanguage('pa')" class="selectable-language-button" mat-menu-item>
            {{ "panjabi" | translate }}
          </button>
        </mat-menu>

      </span>
      <span *ngIf="enImg">
        <img alt="English Active Language Icon" src="/assets/images/Laguage.jpg" />
      </span>
      <span *ngIf="paImg">
        <img alt="Punjabi Active Language Icon" src="/assets/images/Laguage-p.jpg" />
      </span>
    </ng-container>

    <span *ngIf="isHandsetPortrait">
      <mat-icon (click)="handleSideNav()">view_headline</mat-icon>
      <mat-icon (click)="startTour()">info</mat-icon>
    </span>
    <span (click)="goToSearchPage()">
      <mat-icon id="searchIcon" aria-hidden="false" aria-label="Search icon" fontIcon="search"></mat-icon>
    </span>
  </div>
</div>
<!-- header stop -->